<script>
export default {
  inheritAttrs: false,

  props: {
    label: {
      type: String,
      required: true,
    },

    error: {
      type: Boolean,
      required: false,
      default: false,
    },

    options: {
      type: Array,
      required: true,
    },

    required: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    onChange(event) {
      this.$emit('input', event.target.value)
      this.$emit('change', event.target.value)
    },
  },
}
</script>

<template>
  <label :class="{ 'text-error': error }">
    <div class="mb-2 font-medium">
      {{ label }}
      <span v-if="required" class="opacity-50">*</span>
    </div>

    <div class="relative">
      <select
        class="bg-white focus:outline-none border border-gray-300 rounded px-2 py-3 block w-full appearance-none leading-normal"
        v-bind="$attrs"
        :class="{ 'border-error': error }"
        @change="onChange"
      >
        <option v-for="option in options" :key="option.id" :value="option.id">
          {{ option.label }}
        </option>
      </select>
      <div
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
      >
        <svg
          class="fill-current h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
          />
        </svg>
      </div>
    </div>
  </label>
</template>
